// extracted by mini-css-extract-plugin
export default {"cls1":"Unibrow-cls1___84433fd0b62031c7e0d","cls2":"Unibrow-cls2___e899d996d22e145b6cc Unibrow-cls1___84433fd0b62031c7e0d"};